import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CodeTable } from 'src/app/core/model/v2/code-table';
import { HealthOrganizationData } from 'src/app/core/model/v2/practice/HealthOrganizationData';
import { CommonService } from 'src/app/core/services/v2/common.service';
import { SideBarComponentInterface } from 'src/app/shared/components/dynamic-right-sidebar/sideBarComponentInterface';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-setup-organization-form',
  templateUrl: './setup-organization-form.component.html',
  styleUrls: ['./setup-organization-form.component.scss']
})
export class SetupOrganizationFormComponent implements OnInit {

  @Input()
  hoDto: HealthOrganizationData;

  @Input() form: FormGroup;
  statesCodes: CodeTable;
 
  // get isValid() { return this.form.controls["hoDto.name"].valid && this.form.controls["zip"].valid  }

  constructor(private commonService: CommonService, private loaderService: WindowLoaderService) { }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ngOnInit() {

    if(this.form)
    {
      console.log(this.hoDto);
      this.setFormControls();
    }

    this.commonService.GetItemsByCodeNamesWithoutCache(['STATE']).subscribe(
      codeTables => { this.statesCodes = codeTables.codeTable[0]; },
      error => console.log(error)
    );

  }

  private setFormControls() {
    this.form.addControl("healthOrganizationTypeId", new FormControl(this.hoDto.healthOrganizationTypeId||1, [Validators.required]));
    this.form.addControl("name", new FormControl(this.hoDto.name || '', [Validators.required]));
    this.form.addControl("phoneNumber", new FormControl(this.hoDto.phoneNumber || '', []));
    this.form.addControl("webAddress", new FormControl(this.hoDto.webAddress || '', []));
    this.form.addControl("line", new FormControl(this.hoDto.line || '', []));
    this.form.addControl("line2", new FormControl(this.hoDto.line2 || '', []));
    this.form.addControl("city", new FormControl(this.hoDto.city || '', []));
    this.form.addControl("state", new FormControl(this.hoDto.state || '', []));
    this.form.addControl("zipCode", new FormControl(this.hoDto.zipCode || '', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]));
  }
}
